/* eslint-disable no-unused-vars */

import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

const cardCarousel = document.querySelector('.c-carousel');
const cardStack = document.querySelector('.c-stack');

if (cardCarousel) {
  const swiperStack = new Swiper('.c-carousel', {
    slidesPerView: 'auto',
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

if (cardStack) {
  const cardStackDeck = cardStack.getElementsByClassName('c-stack__slide');
  const swiperStack = new Swiper('.c-stack', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => {
        let btnText = '';
        let btnClass = 'c-btn--bullet';
        if (cardStackDeck[index].dataset.slideTitle) {
          btnText = cardStackDeck[index].dataset.slideTitle;
          btnClass = '';
        }
        const pagButton = `<span class="c-btn c-btn--ghost c-btn--large u-margin-right--small ${btnClass} ${className}">${btnText}</span>`;
        return pagButton;
      },
    },
  });

  if (cardStack.dataset.stackSpeed) {
    if (!swiperStack.autoplay.running) {
      swiperStack.params.autoplay = {
        delay: cardStack.dataset.stackSpeed,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      };
      swiperStack.autoplay.start();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/modules/carousel.js